// extracted by mini-css-extract-plugin
export default {"title":"listaNCM_title__mf4Im","container":"listaNCM_container__XIwPX","emptyText":"listaNCM_emptyText__s6KBW"};